export default {
    //cloudapi:'https://cloud.9678auto.com',
    // cloudapi:'https://cloud.gmgauto.one',
    // cloudapi:'https://iprocloud.gmgauto.one',
    // cloudapi:'https://app1cloud.gmgauto.one',
    // cloudapi:'https://app2cloud.gmgauto.one',
    // cloudapi:'https://devxapi.heylinks.live',
    //cloudapi:'https://cloud.usdlink.co', //Dev
    //  cloudapi:'https://xapi.usdlink.info', //PROD
    cloudapi:'https://bigan-xapi.setzero.io', //PROD (เดิม: backend ชุด B udomsub888)
    //cloudapi:'https://sturdy-meme-v646wv44gqpqcpr6p-4001.app.github.dev', // ย้ายมาชุด A: xapi ของ A (port 4001)
    gmz:'USD'
}; 
